import React from 'react';

import { MetaFormContainer } from '../containers/MetaForm';

const ExportPage = () => <MetaFormContainer />;

export { ExportPage };
